// import value from './value.js';
import { booleanDataset } from './utils.js';

class HeaderHero extends HTMLElement {
  async connectedCallback() {
    await new Promise(resolve => setTimeout(resolve));
    this.#listeners();
    this.#tweenBaloons();
  }

  #listeners() {
    this.querySelector('a[data-link-video]')?.addEventListener('click', (e) => {
      e.preventDefault();
      this.#toggleLightbox(e.target.href);
    });
  }

  #toggleLightbox(videoUrl) {
    console.log(videoUrl);
    const gallery = GLightbox({
      elements: [
        {
          'href': videoUrl,
          'type': 'video',
          'source': 'local'
        }
      ],
      autoplayVideos: true,
    });
    gallery.open();
  }

  #tweenBaloons() {
    const els = this.querySelectorAll('[data-baloon]');
    let index = 0;

    const loopBaloons = () => {
      els.forEach((el, i) => {
        booleanDataset(els[i], 'display', i === index);
      });

      index++;
      if (index === 4) {
        index = 0;
      }
    };

    this.baloonsInterval = setInterval(() => loopBaloons(), 2500);
    loopBaloons();
  }
}

customElements.define('header-hero', HeaderHero);
